module.exports = __webpack_public_path__ + "img/证书3.4543830e.jpg";